import { createApi } from '@reduxjs/toolkit/query/react'

import { getBaseQueryWithMockError } from '@/shared/api/custom-fetch-base'

import { IOffice } from '../model/types'

const mock = [
  {
    createdBy: 24,
    createdAt: '2025-04-21T05:06:21.986Z',
    id: 15,
    label: 'Озон',
    marketplaceId: 1,
    clientId: '11',
    companyId: null,
    key: '11',
    organizationId: 10,
    status: null,
  },
  {
    createdBy: 24,
    createdAt: '2025-04-21T05:09:45.987Z',
    id: 16,
    label: '222',
    marketplaceId: 2,
    clientId: 'Валдбери',
    companyId: null,
    key: '111',
    organizationId: 10,
    status: null,
  },
  {
    createdBy: 24,
    createdAt: '2025-04-21T05:09:58.584Z',
    id: 17,
    label: 'Яндя',
    marketplaceId: 3,
    clientId: '123',
    companyId: '123',
    key: '123',
    organizationId: 10,
    status: null,
  },
]

export const officeApi = createApi({
  reducerPath: 'officeApi',
  baseQuery: getBaseQueryWithMockError(mock),
  tagTypes: ['office'],
  endpoints: build => ({
    officeList: build.query<IOffice[], void>({
      query: () => ({
        url: '/user/offices',
        method: 'GET',
      }),
      providesTags: ['office'],
    }),

    createOffice: build.mutation<IOffice, Partial<IOffice>>({
      query: body => ({ url: `/user/offices`, method: 'POST', body }),
      invalidatesTags: ['office'],
    }),

    updateOffice: build.mutation<
      IOffice,
      { id: number | string; body: Partial<IOffice> }
    >({
      query: ({ id, body }) => ({
        url: `/user/offices/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['office'],
    }),

    removeoffice: build.mutation<unknown, number | string>({
      query: id => ({ url: `/user/offices/${id}`, method: 'DELETE' }),
      invalidatesTags: ['office'],
    }),
  }),
})

export const {
  useOfficeListQuery,
  useCreateOfficeMutation,
  useUpdateOfficeMutation,
  useRemoveofficeMutation,
} = officeApi
